import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Switch, Transition} from '@headlessui/react'
import {XMarkIcon} from '@heroicons/react/24/outline'
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    addEventAttribute, adminEventCard, manageEventCard, MetaTags, setUniqueEventAttribute, toastSuccess
} from "../../components/common/utilities";
import {ToastContainer} from "react-toastify";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import {MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {HelmetProvider} from "react-helmet-async";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import {LocalizationProvider} from "@mui/x-date-pickers";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function AdminEventsDashboard() {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let params = useParams();
    const venueID = params.venueID;
    const loaderdata = useLoaderData() as any;
    //console.log(loaderdata);
    const today = new Date();
    const dateString = today.toISOString().split('T')[0];

    const [events, setEvents] = useState([]);
    const [sortCreated, setSortCreated] = useState(false);
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [currentOffset, setCurrentOffset] = useState("");
    const [startDate, setStartDate] = useState("");

    const [isEnd, setIsEnd] = useState(true);
    const [totalSize, setTotalSize] = useState(0);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [NLPStatus, setNLPStatus] = useState([]);
    const [NLPUrl, setNLPUrl] = useState([]);
    const [NLPData, setNLPData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingEvent, setAddingEvent] = useState(false)
    const [gettingEvents, setGettingEvents] = useState(false)
    const [importString, setImportString] = useState('');
    const [showAudience, setShowAudience] = useState(false);
    const [query, setQuery] = useState('');
    const [majorType, setMajorType] = useState('');
    const [dataURL, setDataURL] = useState('https://dashboard.promogogo.com');
    const [userlang, setUserlang] = useState('is');

    const staticurls = [{url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir', name: 'Ads'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=all', name: 'All'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=kids',name: 'Kids'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=elderly', name: 'Elderly'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=christmas', name: 'Christmas'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=currentaffairs',name: 'Current Affairs'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=music', name: 'Music'},
        {url: 'https://dashboard.promogogo.com/p/dynamic/feedtos3.do?site=visir&feedid=theater', name: 'Theater'},
]
    var date = new Date();
    let adminCancelToken;


    function isUrlValid(string)
    {
        try
        {
            new URL(string);
            return true;
        }
        catch (err)
        {
            return false;
        }
    }

    const getEvents = (shouldPoll, sort, offset, start, thetype) => {
        console.log("getting events, created: ", sort);
        if (offset !== currentOffset)
        {
            window.scrollTo(0, 0);
            setEvents([]);
        }
        if (!start || start.length === 0)
        {
            start = startDate;
        }

        if (!thetype)
        {
            thetype = majorType;
        }

        setGettingEvents(true)
        axios.post(dataURL+'/p/manage/event/list.do', {
            ticket: localStorage.getItem('ticket'),
            limit: 100,
            offset: offset,
            created: sort,
            query: query,
            type: thetype,
            lang: userlang,
            startdate: start
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded',
                       }
                   }).then(function (response) {
            // handle success
            console.log("events", response);
            setEvents(response.data.collection);
            setNextOffset(response.data.pagination.nextOffset);
            setPreviousOffset(response.data.pagination.previousOffset);
            setTotalSize(response.data.pagination.totalSize);
            setIsEnd(response.data.pagination.end);
            setGettingEvents(false)
        });
    }

    const setStaticFiles = () => {
        staticurls.forEach((url) => {
            axios.get(url.url).then(function (response) {
                toastSuccess("Set static feed for " + url.name )
            })

        }, [])
    };

    const toggleSort = (sort) => {
        console.log("toggle sort", sort);
        setEvents([]);
        setSortCreated(sort);
        getEvents(false, sort, 0, "", "");

    }

    const toggleAudience = (sort) => {
        console.log("toggle sort", sort);

        setShowAudience(sort);


    }

    let controller;

    const handleAdminSearchChange = (e) => {

        const searchTerm = e.target.value
        if (controller !== undefined && controller !== null)
        {
            console.log("Aborted previous request", controller.signal.aborted)

            //adminCancelToken.cancel("Operation canceled due to new request.")
            controller.abort()

        }
        controller = new AbortController();

        setQuery(searchTerm)


        //Check if there are any previous pending requests


        //Save the cancel token for the current request

        //adminCancelToken = axios.CancelToken.source()
        setEvents([])

        try
        {

            axios.get(dataURL+'/p/manage/event/list.do?q=' + searchTerm,

                      {signal: controller.signal} //Pass the cancel token to the current request

            ).then(function (response) {

                console.log("Results for " + searchTerm + ": ", response.data)

                setEvents(response.data.collection)
            })

        }
        catch (error)
        {

            console.log(error)

        }
    }


    useEffect(() => {
        const userlang = localStorage.getItem('userlang');
        if(userlang)
        {
            setUserlang(userlang);
        }

        getEvents(false, sortCreated, currentOffset, "", "");

    }, []);

    // EDIT EVENT DIALOG

    const [open, setOpen] = useState(false);

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    type SchemaLocation = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const [eventData, setEventData] = useState<SchemaEvent>();
    const [venueData, setVenueData] = useState<SchemaLocation>();


    const createEvent = (e) => {
        e.preventDefault();
        console.log('posting ', eventData);
        axios.post(`${process.env.REACT_APP_API_URL}/go/api/event/create.do`, eventData, {}).then(function (response) {
            // handle success
            console.log(response);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }


    const viewEvent = (event, eventid) => {
        setEventData(null);
        setOpen(true);
        const serverName = window.location.hostname;
        let apipath = "/p/manage/event.do";
        if(serverName.startsWith("dev.promogogo"))
        {
            apipath = "/v1/event/"+eventid;
        }

        axios.get(`${process.env.REACT_APP_API_URL}`+apipath, {
            params: {
                event: eventid, tiny: true, admin: true, lang:userlang, ticket: localStorage.getItem('ticket'),
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            let eventData = response.data;
            setEventData(eventData);

        });

    }

    const changeUserLang = (e) => {
        e.preventDefault();
        let lang = e.target.value;
        setUserlang(lang);
        localStorage.setItem('userlang', lang);
        getEvents(false, sortCreated, currentOffset, "", majorType);
    }

    const showByType = (e) => {
        e.preventDefault();
        let type = e.target.value;
        setMajorType(type);
        getEvents(false, sortCreated, currentOffset, "", type);
    }

    const changeName = e => {
        e.preventDefault();
        alert('change name');
        /*axios.post(`${process.env.REACT_APP_API_URL}/keepsapi/api/createroom.do`, {
            instance: 'keeps',
            ticket: localStorage.getItem('ticket'),
            property: data['guid'],
            title: roomtitle,
            description: roomdescription,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            //setRooms(response.data.collection);
            window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });*/
    }

    function changeStart(e)
    {
        console.log(e._d);
        var d = new Date(e._d);

        console.log(d.toISOString());
        setEvents([]);
        setStartDate(d.toISOString());
        getEvents(false, sortCreated, currentOffset, d.toISOString(), majorType)
    }

    function changeStartDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localStartDate: e._i
                     })
    }

    function changeEndDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localEndDate: e._i
                     })
    }

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            if (value === 'true')
            {
                toastSuccess('Event set to public');
            }
            else
            {
                toastSuccess('Event set to private');
            }

        }
        else if (button === 'viewEvent')
        {
            let eventid = e.target.dataset.eventid;
            viewEvent(null, eventid);
        }
        else if (button === 'setAttractionType')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Attraction Type set to ' + value);

        }

        else if (button === 'addAttribute')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = false;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            addEventAttribute(key, value, unique, eventid);

            toastSuccess('Attribute ' + key + ' set to ' + value);

        }

        else if (button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute('pgg.audience.' + key, 'pgg.audience.' + value, unique, remove, eventid);

            toastSuccess('Audience set ' + key + ' Remove: ' + remove);

        }

        /*let venueid = e.target.dataset.venueid;
        if (venueid !== undefined)
        {
            console.log(`Event bubbled up to div from `, venueid);
            //console.log(eventData);
            let venuename = e.target.dataset.venuename;
            let venueimage = e.target.dataset.venueimage;

            var locationData = eventData.location;
            locationData.name = venuename;
            locationData.image = venueimage;
            locationData['@id'] = venueid;

            setVenueData(locationData);

            setEventData({
                             ...eventData, location: {
                    locationData
                }

                         })
            console.log(eventData);

        }*/


    }

    const importURL = (event, eventurl) => {
        console.log(event);
        event.currentTarget.classList.toggle('fa-spin');
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: eventurl, importmore: true, ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                //event.target.elements.text.value = '';
                setAddingEvent(false)
                event.currentTarget.classList.toggle('fa-spin');
                getEvents(null, sortCreated, 0, "", majorType);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const importEvent = (event) => {
        event.preventDefault()
        setAddingEvent(true)
        if (!isUrlValid(event.target.elements.text.value))
        {
            alert("Invalid URL");
            setImportString('');
            setAddingEvent(false)
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: event.target.elements.text.value, ticket: localStorage.getItem('ticket'), importmore: true
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                event.target.elements.text.value = '';
                setAddingEvent(false)
                setImportString('');
                getEvents(null, sortCreated, 0, "", majorType);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const handlePasteImport = event => {
        var eventurl = event.clipboardData.getData('text');
        setImportString(eventurl);
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            setImportString('');
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_API_URL}/p/api/event/import.do`, {
                eventurl: eventurl, ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                setAddingEvent(false)
                getEvents(null, sortCreated, 0, "", majorType);
                setImportString('');
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }
    };

    return <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full">
        <body class="h-full">
        ```
      */}
        <MetaTags
            title='Admin Events Dashboard'
            description='Manage your events, artists and venues. Get ready to promote your next event.'
            image='https://promogogo.com/cdn-cgi/image/fit=contain,width=768/https://media.promogogo.com/ymsirvidburdir/2024-06-10/3666078aaa094262b626960bf705498b.png'
            name='Team Mobilitus'
        />

        <div className="min-h-full dark:bg-white bg-white">
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div
                                                className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">
                                                            Event Details
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-red-700 text-white hover:bg-red-500 hover:outline-none hover:ring-2 hobver:ring-red-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {eventData && eventData.name && <div className="px-4 py-5 sm:p-6"
                                                                                         onClick={(event) => clickedEvent(event)}>
                                                        {adminEventCard(eventData)}
                                                    </div>}
                                                    {!eventData &&
                                                     <div className="p-4 text-gray-800 flex justify-center">
                                                         <div className={'text-pg_yellow'}><i
                                                                 className="fa-2x fa-duotone fa-loader fa-spin"></i>
                                                         </div>
                                                     </div>}

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>

            <div className="lg:pl-72">
                <div className={'flex items-center justify-between bg-white p-4'}>
                    {totalSize > 0 && <div className="p-2 text-sm text-gray-800">Total events: {totalSize}</div>}

                    <div className={'mt-1'}>
                        <div className={'text-gray-500 text-xs'}>Language</div>
                        <select
                            onChange={(e) => changeUserLang(e)}
                            value={userlang}
                            className="rounded-md px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                            <option value="is">IS</option>
                            <option value={'en'}>EN</option>
                            <option value={'da'}>DA</option>
                        </select>
                    </div>
                    <button className={'bg-blue-500 text-white p-2 rounded-md'} onClick={() => setStaticFiles()}>Set
                        Static Files
                    </button>
                </div>

                <main className="mt-2">
                    <div className="px-4 sm:px-6 lg:px-8">
                        <div className="grid md:grid-cols-2">
                            <div className={'col-span-1 grid grid-cols-3'}>
                                <div className={'col-span-1'}>
                                    <div className={'text-gray-500 text-xs'}>Created</div>
                                    <div className={'mt-3'}>
                                        <Switch
                                            checked={sortCreated}
                                            onChange={toggleSort}
                                            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                    </div>
                                </div>
                                <div className={'col-span-1'}>
                                    <div className={'text-gray-500 text-xs'}>Show audience</div>
                                    <div className={'mt-3'}>
                                        <Switch
                                            checked={showAudience}
                                            onChange={toggleAudience}
                                            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                                        >
                                            <span className="sr-only">Use setting</span>
                                            <span
                                                aria-hidden="true"
                                                className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                            />
                                        </Switch>
                                    </div>
                                </div>
                                <div className={'col-span-1'}>
                                    <div className={'text-gray-500 text-xs'}>Type</div>
                                    <div className={'mt-1'}>
                                        <select
                                            onChange={(e) => showByType(e)}
                                            value={majorType}
                                            className="rounded-md px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                            <option value="">All</option>
                                            <option value={'arts'}>Arts</option>
                                            <option value={'burlesque'}>Burlesque/Drag</option>
                                            <option value={'community'}>Community</option>
                                            <option value={'exhibition'}>Exhibitions</option>
                                            <option value={'festival'}>Festivals</option>
                                            <option value={'music'}>Music</option>
                                            <option value={'sports'}>Sports</option>
                                            <option value={'standup'}>Standup</option>
                                            <option value={'theatre'}>Theatre</option>
                                        </select>
                                    </div>
                                </div>

                            </div>

                            <div className={'col-span-1 md:grid md:grid-cols-2'}>

                                <div className={'md:col-span-1'}>
                                    <form className="relative flex flex-1" action="#" method="GET">
                                        <label htmlFor="search-field" className="sr-only">
                                            Search
                                        </label>
                                        <MagnifyingGlassIcon
                                            className="pointer-events-none absolute inset-y-0 mt-1 left-1 h-full w-5 text-gray-400"
                                            aria-hidden="true"
                                        />
                                        <input
                                            id="search-field"
                                            className=" rounded border-gray-300 mt-2 p-4 pl-6 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm "
                                            placeholder="Search admin..."
                                            defaultValue={query}
                                            type="search"
                                            name="search"
                                            onKeyUp={e => handleAdminSearchChange(e)}
                                        />

                                    </form>
                                </div>
                                <div className={'md:col-span-1 mt-2'}>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en-gb">
                                        <DatePicker
                                            label="Date"
                                            name={'date'}
                                            defaultValue={moment(dateString)}
                                            onChange={changeStart}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="px-4 sm:px-6 lg:px-2">
                            <nav
                                className="sticky bg-white z-30 flex items-center justify-between px-4 sm:px-0  mt-2 mb-2"
                                style={{top: "60px"}}>
                                <div className="-mt-px flex w-0 flex-1">
                                    <div
                                        onClick={() => getEvents(null, sortCreated, 0, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                    >
                                        <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                               aria-hidden="true"/>

                                    </div>
                                </div>
                                <div className="-mt-px md:flex">
                                    <div
                                        onClick={() => getEvents(null, sortCreated, previousOffset, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-b-2 border-transparent pr-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                    >
                                        <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                           aria-hidden="true"/>

                                    </div>
                                    <div
                                        onClick={() => getEvents(null, sortCreated, nextOffset, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-b-2 border-transparent pl-1 pb-2 pt-2 text-sm font-medium text-gray-500 hover:border-blue-500 hover:text-gray-700"
                                    >

                                        <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400"
                                                            aria-hidden="true"/>
                                    </div>

                                </div>
                                <div className="-mt-px flex w-0 flex-1">

                                </div>
                            </nav>
                            {events && events.length > 0 && <div onClick={(event) => clickedEvent(event)}>
                                {events.map(event => <div key={event['@id']}>
                                    {manageEventCard(event,showAudience)}
                                </div>)}
                            </div>}
                            {events && events.length === 0 && <div className="p-4 text-gray-800 flex justify-center">
                                <div className={'text-pg_yellow'}><i
                                        className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                            </div>}


                            <nav
                                className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0  mt-2 mb-2"
                                id={'topnav'}>
                                <div className="-mt-px flex w-0 flex-1">
                                    <div
                                        onClick={() => getEvents(null, sortCreated, 0, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-blue-300 hover:text-gray-700"
                                    >
                                        <ChevronDoubleLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                               aria-hidden="true"/>

                                    </div>
                                </div>
                                <div className="hidden md:-mt-px md:flex">

                                    <div
                                        onClick={() => getEvents(null, sortCreated, previousOffset, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                    >
                                        <ArrowLongLeftIcon className="mr-3 h-5 w-5 text-gray-400"
                                                           aria-hidden="true"/>
                                    </div>
                                    <div
                                        onClick={() => getEvents(null, sortCreated, nextOffset, "", majorType)}
                                        className="cursor-pointer inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                    >
                                        <ArrowLongRightIcon className="ml-3 h-5 w-5 text-gray-400"
                                                            aria-hidden="true"/>
                                    </div>
                                </div>
                                <div className="-mt-px flex w-0 flex-1 justify-end">

                                </div>
                            </nav>


                            <div className="-mx-4 mt-2 sm:-mx-0">
                            </div>
                        </div>
                    </div>
                </main>

            </div>
        </div>
        <ToastContainer autoClose={800} theme={'dark'}/>
    </>
}
